/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reingest_Approval_DeniedInputs */

const es_components_reingest_approval_denied = /** @type {(inputs: Components_Reingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingesta denegada`)
};

const en_components_reingest_approval_denied = /** @type {(inputs: Components_Reingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingestion denied`)
};

/**
* | output |
* | --- |
* | "Re-ingestion denied" |
*
* @param {Components_Reingest_Approval_DeniedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reingest_approval_denied = /** @type {((inputs?: Components_Reingest_Approval_DeniedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reingest_Approval_DeniedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reingest_approval_denied(inputs)
	return en_components_reingest_approval_denied(inputs)
});
export { components_reingest_approval_denied as "components.reingest_approval.denied" }